import { FC } from 'react';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import LoadingButton from '@mui/lab/LoadingButton';
import Save from '@mui/icons-material/Save';

import { useRouter } from '@cvt/routing';
import { useBlockedNavigate } from '@cvt/contexts';
import { useDictionary } from '@cvt/hooks/useDictionary';


type Props = {
  title: string,
  isSaving: boolean,
}

export const StoryHeader: FC<Props> = ({ title, isSaving }) => {
  const router = useRouter();
  const navigate = useBlockedNavigate();
  const dictionary =  useDictionary();

  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      gap={4}
      position="sticky"
      top="2.5rem"
      py={2}
      bgcolor="white"
      zIndex={2}
    >
      <Button variant="outlined" color="primary" onClick={() => navigate(router.stories.path)}>
        {dictionary.routes.back}
      </Button>
      <Typography variant="body1" fontSize={30} fontWeight={600} textAlign="center">
        {title}
      </Typography>
      <LoadingButton
        variant="contained"
        color="primary"
        size="large"
        type="submit"
        startIcon={<Save/>}
        loading={isSaving}
        form="story-form"
      >
        {dictionary.forms.buttonSaveShort}
      </LoadingButton>
    </Stack>
  );
};
